import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ServiceInfoClientService } from '../../service/service-info-client.service';
import {
  Directions,
  InfoCompany,
  UpdateActiviesCompany,
  UpdateCompany,
} from '../../interface/company-client.interface';
import { ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
const reg = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';

@Component({
  selector: 'app-update-information',
  templateUrl: './update-information.component.html',
  styleUrls: ['./update-information.component.scss'],
})
export class UpdateInformationComponent implements OnInit {
  public isLoading: boolean = false;
  public rutUrl: number;
  public update: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: InfoCompany,
    private dialogRef: MatDialogRef<UpdateInformationComponent>,
    private _userService: ServiceInfoClientService,
    private route: ActivatedRoute
  ) {}
  ngOnInit(): void {
    this.fillUpdateWithUser(this.data);
    this.route.queryParams.subscribe((params: any) => {
      const { client } = params;
      this.rutUrl = parseInt(client);
    });
  }

  public form = new FormGroup({
    website: new FormControl<string | null>('', ),
    phone: new FormControl<string | null>(null, []),
    email: new FormControl<string | null>(null,),
    direction: new FormControl<string>(null),
    commune: new FormControl<string>(null,),
    address: new FormControl<string | null>(null,),
    addressNumber: new FormControl<string | null>(null,),
    addressOffice: new FormControl<string | null>(null),
    region: new FormControl<string | null>(null,),
    contactName: new FormControl<string | null>(null),
    name: new FormControl<string | null>(null),
    companyCategory: new FormControl<string | null>(null),
  });

  closeDialog() {
    this.dialogRef.close();
  }

  get f() {
    return this.form.controls;
  }

  private fillUpdateWithUser(user: InfoCompany) {
    this.form.patchValue({
      address: user.addressStreet,
      website: user.website,
      name: user.name,
      phone: user.phone,
      email: user.email,
      commune: user.comune,
      addressNumber: user.addressNumber,
      addressOffice: user.addressOffice,
      region: user.region,
      contactName: user.contactName,
      companyCategory: user.businessSize,
    });
    // const address = user.address.split(',').map((part) => part.trim());
    // this.form.patchValue({
    //   direction: address[0],
    //   commune: address[1],
    // });
  }

  public submitForm() {
    const direccion: Directions = {
      direccion: this.form.get('address')?.value,
      comuna: this.form.get('commune')?.value,
      addressNumber: this.form.get('addressNumber')?.value,
      addressOffice: this.form.get('addressOffice')?.value,
      region: this.form.get('region')?.value,
    };

    const request: UpdateCompany = {
      webSite: this.form.get('website')?.value,
      email: this.form.get('email')?.value,
      telefono: this.form.get('phone')?.value,
      direcciones: new Array<Directions>(direccion),
      contactName: this.form.get('contactName')?.value,
      name: this.form.get('name')?.value,
      companyCategory: this.form.get('companyCategory')?.value,
    };

    Swal.fire({
      title: 'Actualizando Cliente',
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading();
        this._userService.updateInfo(this.rutUrl, request).subscribe({
          next: (res) => {
            this.update = true;
            Swal.fire({
              title: 'Datos actualizados',
              icon: 'success',
            }).then((res) => {
              if (res.isConfirmed) {
                this.dialogRef.close(this.update);
              }
            });
          },
          
        });
      },
    });
  }
}
